/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookCountJPAModel
 */
export interface BookCountJPAModel {
    /**
     * 
     * @type {number}
     * @memberof BookCountJPAModel
     */
    bookCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BookCountJPAModel
     */
    categoryId?: number;
}

export function BookCountJPAModelFromJSON(json: any): BookCountJPAModel {
    return BookCountJPAModelFromJSONTyped(json, false);
}

export function BookCountJPAModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookCountJPAModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookCount': !exists(json, 'bookCount') ? undefined : json['bookCount'],
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
    };
}

export function BookCountJPAModelToJSON(value?: BookCountJPAModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bookCount': value.bookCount,
        'categoryId': value.categoryId,
    };
}

